import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SettingModel } from 'Models'
import { Callback } from 'Types/utilTypes'

export type SettingState = {
	setting: Map<string, SettingModel>
}

const initialState: SettingState = {
	setting: new Map(),
}

export namespace SettingNS {
	export type GetAll = PayloadAction
	export type SetAll = PayloadAction<Map<string, SettingModel>>
	export type GetSetting = PayloadAction<string>
	export type SetSetting = PayloadAction<SettingModel>
	export type UpdateSetting = PayloadAction<{
		setting: { [key: string]: any }
		key: string
		callback?: Callback
	}>
	export type GetEvents = PayloadAction
}

export const settingSlice = createSlice({
	name: 'setting',
	initialState,
	reducers: {
		getAll: (state, action: SettingNS.GetAll) => {},
		setAll: (state, action: SettingNS.SetAll) => {
			state.setting = action.payload
		},
		getSetting: (state, action: SettingNS.GetSetting) => {},
		setSetting: (state, action: SettingNS.SetSetting) => {
			const { key, data } = action.payload
			// @ts-ignore
			state.setting.set(key, data)
		},
		updateSetting: (state, action: SettingNS.UpdateSetting) => {},
		getEvents: (state, action: SettingNS.GetEvents) => {},
	},
})
